import React from 'react';
import classes from './PostCardLinkPreview.module.scss';
import classNames from 'classnames';
import { ReactComponent as LinkPreviewNoImage } from '../../../assets/images/linkPreviewNoImage.svg';
import { extractLinkUrlDetails } from '../../../modules/Discover/FindContent/findContentHelpers';

export enum PostCardLinkPreviewSizeEnum {
  small,
  medium,
  large
}

export type PostCardLinkPreviewViewProps = {
  linkUrl: string;
  thumbnailUrl?: string;
  title?: string;
  size: PostCardLinkPreviewSizeEnum;
};

const NoImagePlaceholder = ({ size }: { size: PostCardLinkPreviewSizeEnum }): JSX.Element => {
  const noImageContainerClasses = classNames(classes.NoImageContainer, {
    [classes.NoImageContainerSmall]: size === PostCardLinkPreviewSizeEnum.small,
    [classes.NoImageContainerMedium]: size === PostCardLinkPreviewSizeEnum.medium,
    [classes.NoImageContainerLarge]: size === PostCardLinkPreviewSizeEnum.large
  });

  return (
    <div className={noImageContainerClasses}>
      <div className={classes.NoImageIconWrapper}>
        <LinkPreviewNoImage />
      </div>
    </div>
  );
};
export const PostCardLinkPreviewView = ({
  linkUrl,
  thumbnailUrl,
  title,
  size
}: PostCardLinkPreviewViewProps): JSX.Element => {
  const urlParams = extractLinkUrlDetails(linkUrl);

  const linkPreviewClasses = classNames('margin-top-small-8', 'margin-bottom-small-8', classes.PostCardLinkPreview, {
    [classes.PostCardLinkPreviewSmall]: size === PostCardLinkPreviewSizeEnum.small,
    [classes.PostCardLinkPreviewMedium]: size === PostCardLinkPreviewSizeEnum.medium
  });
  const linkDetailsWrapperClasses = classNames(classes.LinkDetailsWrapper, {
    [classes.LinkDetailsWrapperSmall]: size === PostCardLinkPreviewSizeEnum.small,
    [classes.LinkDetailsWrapperMedium]: size === PostCardLinkPreviewSizeEnum.medium
  });
  const linkUrlClasses = classNames(classes.Link);
  const linkTitleClasses = classNames(classes.Title);
  const mediaWrapperClasses = classNames(classes.MediaWrapper, {
    [classes.MediaWrapperSmall]: size === PostCardLinkPreviewSizeEnum.small,
    [classes.MediaWrapperMedium]: size === PostCardLinkPreviewSizeEnum.medium
  });

  return (
    <div className={linkPreviewClasses}>
      <div className={classes.MediaContainer}>
        {thumbnailUrl ? (
          <div className={mediaWrapperClasses}>
            <img src={thumbnailUrl} alt={'post media'} />
          </div>
        ) : (
          <NoImagePlaceholder size={size} />
        )}
      </div>
      <div className={classes.LinkDetailsContainer}>
        <div className={linkDetailsWrapperClasses}>
          <div
            className={linkUrlClasses}
            onClick={() => window.open(urlParams?.url.href, '_blank', 'noopener,noreferrer')}>
            {urlParams?.domain || linkUrl}
          </div>
          {title && <div className={linkTitleClasses}>{title}</div>}
        </div>
      </div>
    </div>
  );
};
